import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Types.
 */

interface RuleAddCardProps {
  label: ReactNode;
}

/*
 * Styles.
 */

const RuleAddCardWrapInner = styled.div`
  display: grid;
  grid-template-columns: 30px auto 20px;
  grid-gap: 0;
  align-items: center;
  border-radius: 12px;
  padding: 10px 12px;
  background-color: ${(p) => p.theme.alphas.transparent};
  transition: background-color 0.12s linear;
`;

const RuleAddCardWrap = styled.div`
  border-radius: 16px;
  padding: 2px;
  border: 1px dashed ${(p) => p.theme.palette.grey.shade30};
  line-height: 30px;
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.palette.blue.shade40};
  font-weight: ${fontWeights.semibold};

  &:hover {
    border-color: ${(p) => p.theme.palette.blue.shade40};

    ${RuleAddCardWrapInner} {
      background-color: ${(p) => p.theme.palette.grey.shade20};
    }
  }
`;

const RuleAddCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  color: ${(p) => p.theme.palette.blue.shade40};
`;

/*
 * Component.
 */

export const RuleAddCard: FC<RuleAddCardProps> = (props) => {
  const {label} = props;

  return (
    <RuleAddCardWrap>
      <RuleAddCardWrapInner>
        <RuleAddCardIcon>
          <Icon name="plusCircleFilledSmall" />
        </RuleAddCardIcon>
        <span>{label}</span>
      </RuleAddCardWrapInner>
    </RuleAddCardWrap>
  );
};
